import { download } from "./download";
import { Toolbar, Button, TopToolbar, CreateButton } from "react-admin";
import { default as xls } from "../app/icon/xls.svg";
import { settings } from "../app";
export const extractQuery = ({ filterValues, page, perPage, sort }) => {
  const sortQuery = sort?.field && sort?.order ? `&SortBy=${sort?.field}&SortOrder=${sort?.order}` : "";
  let filterParams = `?CurrentPage=${page}&PerPage=${perPage}${sortQuery}`;

  Object.keys(filterValues).forEach(key => {
    filterParams += `&${key}=${filterValues[key]}`;
  });
  return filterParams;
};
const SvgIcon = () => {
  return (
    <img
      alt=""
      src={xls}
      style={{ maxWidth: "1.5em", paddingTop: "0" }}
    />
  );
};
export const DownloadTopToolbarButton = ({ props, customResources, fileName, filterParams }) => {
  return (
    <Toolbar
      {...props}
      sx={{
        background: "transparent",
        "&.RaToolbar-desktopToolbar": {
          minHeight: "unset",
        },
      }}
    >
      <Button
        color="primary"
        startIcon={<SvgIcon />}
        label="EXCEL"
        sx={{ color: "#065006", fontWeight: 900, fontSize: ".9em" }}
        onClick={() => download(`${settings.gatewayApi}/${customResources}${extractQuery(filterParams)}`, fileName)}
      />
    </Toolbar>
  );
};

export const CreateActions = () => {
  return (
    <TopToolbar>
      <CreateButton />
    </TopToolbar>
  );
};
